/* eslint-disable no-useless-escape */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import slugify from "slugify";
import { PulseLoader } from "react-spinners";
import { APIContext } from "../../api/api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import profilePhoto from "../../assets/profile_photo.svg";
import HelmetLayout from "../../components/HelmetLayout";
import Creatable from "react-select/creatable";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
  Select,
} from "@chakra-ui/react";

function EditTemplate({ isNew }) {
  const navigate = useNavigate();
  const { templateID } = useParams();
  const { getTemplate, deleteTemplate, createNewTemplate, updateTemplate } =
    useContext(APIContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(true);
  const [templateData, setTemplateData] = useState({});
  const [templateName, setTemplateName] = useState("");
  const [templateCategory, setTemplateCategory] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [templateJSON, setTemplateJSON] = useState("");
  const [templateThumbnail, setTemplateThumbnail] = useState("");
  const [templateThumbnailFile, setTemplateThumbnailFile] = useState(null);
  const [templateMeta, setTemplateMeta] = useState("");
  const [isTemplateDeleting, setIsTemplateDeleting] = useState(false);
  const [isTemplateUpdating, setIsTemplateUpdating] = useState(false);

  const thumbnailRef = React.useRef(null);

  useEffect(() => {
    if (!isNew) {
      getTemplate(templateID).then((templatedata) => {
        setTemplateData(templatedata);
        setLoading(false);
        setTemplateName(templatedata.template_name);
        setTemplateDescription(templatedata.template_description);
        setTemplateCategory(templatedata.template_category);
        setTemplateJSON(templatedata.template_json);
        setTemplateThumbnail(templatedata.template_thumbnail);
        setTemplateMeta(templatedata.template_meta);
      });
    } else {
      setLoading(false);
    }
  }, []);

  console.log(templateCategory);

  return (
    <>
      <HelmetLayout title={isNew ? "New Template" : `${templateName} - Edit Template`} />
      {!loading && (
        <div className="flex-1 h-screen overflow-y-scroll bg-[#FFFFFF] items-start p-7">
          <div className="flex flex-col items-start justify-center">
            <div className="w-full flex flex-row justify-between mb-6">
              <h1 className="text-[32px]">
                {
                  isNew ? "New Template" : `${templateName} - Edit Template`
                }
              </h1>
              <img
                src={profilePhoto}
                className="mr-4 h-9"
                alt="user-profile-img"
              />
            </div>
            <div className="w-[700px] flex flex-col justify-start p-7 gap-y-5">
              <div>
                <label
                  htmlFor="name"
                  className="block text-lg text-[#121212] font-medium"
                >
                  Name
                </label>
                <input
                  value={templateName}
                  onChange={(event) => setTemplateName(event.target.value)}
                  className="block mt-2 w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                />
              </div>
              <div>
                <label
                  htmlFor="description"
                  className="block text-lg text-[#121212] font-medium"
                >
                  Description
                </label>
                <textarea
                  rows="3"
                  value={templateDescription}
                  onChange={(event) => setTemplateDescription(event.target.value)}
                  className="block mt-2 w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                />
              </div>
              <div>
                <label
                  htmlFor="json"
                  className="block text-lg text-[#121212] font-medium"
                >
                  JSON Data
                </label>
                <textarea
                  rows="10"
                  value={templateJSON}
                  onChange={(event) => setTemplateJSON(event.target.value)}
                  className="block mt-2 w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                />
              </div>
              <div>
                <label
                  htmlFor="thumbnail"
                  className="block text-lg text-[#121212] font-medium"
                >
                  Thumbnail
                </label>
                {
                  templateThumbnail && (
                <div>
                  <img
                    src={templateThumbnail}
                    alt="template-thumbnail"
                    className="w-[400px] h-auto object-contain rounded-3xl"
                  />
                </div>
                  )
                }
                {/* Button to add or replace thumbnail */}
                <div className="flex flex-row gap-2 items-center mt-2">
                  <button
                    onClick={e=>{
                      e.preventDefault();
                      thumbnailRef.current.click();
                    }}
                    className="px-4 py-2 text-center text-[16px] text-[#5CBD20] font-medium rounded-[20px] shadow-card-box-shadow border border-solid border-[#5CBD20]"
                  >
                    {
                      templateThumbnail ? "Replace Thumbnail" : "Add Thumbnail"
                    }
                  </button>
                </div>
                    {/* File Input for thumbnail */}
                    <input
                      ref={thumbnailRef}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(event) => {
                        const file = event.target.files[0];
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                          setTemplateThumbnail(reader.result);
                        };
                        setTemplateThumbnailFile(file);
                      }}
                    />
              </div>
              <div>
                <label
                  htmlFor="text"
                  className="block text-lg text-[#121212] font-medium"
                >
                  Category
                </label>
                <Select
                  placeholder='Select category'
                  value={templateCategory}
                  onChange={(event) => {
                    setTemplateCategory(event.target.value);
                  }}
                >
                  {/* Business, portfolio, ecommerce, blog, landing, etc. */}
                  <option value="about">About Us</option>
                  <option value="privacy">Privacy Policy</option>
                  <option value="term">Terms of Service</option>
                  <option value="blog">Blog</option>
                  <option value="landing">Landing Page</option>
                  <option value="contact">Contact Us</option>
                  <option value="portfolio">Portfolio</option>
                  <option value="pricing">Pricing</option>
                </Select>
              </div>
              <div>
                <label
                  htmlFor="text"
                  className="block text-lg text-[#121212] font-medium"
                >
                  Keywords
                </label>
                <Creatable
                  isMulti
                  options={[]}
                  value={templateMeta?.keyword || []}
                  onChange={(selectedOptions) => {
                    setTemplateMeta({
                      ...templateMeta || {},
                      keyword: selectedOptions,
                    });
                  }}
                  onCreateOption={(inputValue) => {
                    const slug = slugify(inputValue, {
                      trim: false,
                      strict: true,
                      lower: true,
                    });
                    const newOption = { value: slug, label: inputValue };
                    setTemplateMeta({
                      ...templateMeta || {},
                      keyword: [...(templateMeta?.keyword || []), newOption],
                    });
                  }}
                  className="block mt-2 w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                />
              </div>
            </div>
            <div className="px-7 flex justify-center items-center gap-6 mt-5">
              <button
                onClick={() => {
                  if (isTemplateUpdating) {
                    return;
                  }
                  setIsTemplateUpdating(true);

                  if (isNew) {
                    createNewTemplate(
                      templateName,
                      templateDescription,
                      templateThumbnailFile,
                      templateCategory,
                      templateMeta,
                      templateJSON,
                    )
                      .then((res) => {
                        setIsTemplateUpdating(false);
                        navigate("/templates");
                      })
                      .catch((error) => {
                        console.error(error);
                        setIsTemplateUpdating(false);
                      });
                    return;
                  }

                  updateTemplate(
                    templateID,
                    templateName,
                    templateDescription,
                    templateThumbnailFile,
                    templateCategory,
                    templateMeta,
                    templateJSON,
                  )
                    .then((res) => {
                      setIsTemplateUpdating(false);
                      toast.success("Template Updated!", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    })
                    .catch((error) => {
                      console.log(error);
                      setIsTemplateUpdating(false);
                    });
                }}
                className="px-3 py-[9px] text-left text-[16px] text-[#5CBD20] font-medium rounded-[20px] shadow-card-box-shadow border border-solid border-[#5CBD20]"
              >
                {isTemplateUpdating ? (
                  <PulseLoader size={8}></PulseLoader>
                ) : (
                  isNew ? "Create" : "Update"
                )}
              </button>
              {
                !isNew && (
                  <button
                    onClick={onOpen}
                    className="px-3 py-[9px] text-left text-[16px] text-[#DE1111] font-medium rounded-[20px] shadow-card-box-shadow border border-solid border-[#DE1111]"
                  >
                    Delete
                  </button>
                )
              }
              <Modal
                blockScrollOnMount={false}
                isOpen={isOpen}
                onClose={onClose}
                borderRadius="20px"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalCloseButton />
                  <ModalHeader
                    mt="20px"
                    textAlign="center"
                    fontSize="24px"
                    fontWeight="medium"
                  >
                    Delete Template
                  </ModalHeader>
                  <ModalBody>
                    <Text
                      color="#121213"
                      textAlign="center"
                      fontWeight="normal"
                      fontSize="16px"
                      mb="1rem"
                    >
                      This will permanently delete the template.
                    </Text>
                  </ModalBody>
                  <ModalFooter>
                    <Box width="100%" display="flex" justifyContent="center">
                      <Box
                        onClick={() => {
                          if (isTemplateDeleting) {
                            return;
                          }
                          setIsTemplateDeleting(true);
                          deleteTemplate(templateID)
                            .then((res) => {
                              setIsTemplateDeleting(false);
                              toast.success("Template Deleted!", {
                                position: toast.POSITION.TOP_RIGHT,
                              });
                              navigate("/templates");
                            })
                            .catch((error) => {
                              console.error(error.message);
                              setIsTemplateDeleting(false);
                            });
                        }}
                        as="button"
                        width="150px"
                        height="48px"
                        lineHeight="1.2"
                        px="8px"
                        borderRadius="20px"
                        fontSize="16px"
                        fontWeight="normal"
                        bg="#DE1111"
                        color="#ffffff"
                        mb="30px"
                        _focus={{
                          boxShadow:
                            "0px 70.8569px 51.2194px rgba(41, 72, 152, 0.037963), 0px 42.1092px 27.8569px rgba(41, 72, 152, 0.0303704), 0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025)",
                        }}
                      >
                        {isTemplateDeleting ? (
                          <PulseLoader size={8}></PulseLoader>
                        ) : (
                          "Delete"
                        )}
                      </Box>
                    </Box>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EditTemplate;
